// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---ZDlcU","sk-bouncedelay":"sk-bouncedelay---ko6Gy","bounce1":"bounce1---az0pL","bounce2":"bounce2---b8u0I"};